import React from "react";
import { motion } from "framer-motion";
import { useLanguage } from "../context/LanguageContext";
import { t3, pick3 } from "../i18n/v3";
import { PageShell, PageHeader } from "../components/PageShell";
import PageBackdrop from "../components/PageBackdrop";

const ease = [0.16, 1, 0.3, 1];

export default function LighthousePage() {
    const { lang } = useLanguage();
    const pillars = pick3(t3.lighthouse.pillars, lang);

    return (
        <PageShell testId="page-lighthouse" backdrop={<PageBackdrop variant="lighthouse" />}>
            <PageHeader
                overline={pick3(t3.lighthouse.overline, lang)}
                title={pick3(t3.lighthouse.title, lang)}
                kicker={pick3(t3.lighthouse.lede, lang)}
            />

            {/* Symbol echo — a soft horizon beam, not a repeated logo */}
            <div aria-hidden className="mt-4 mb-16 h-px bg-gradient-to-r from-[color:var(--gold)]/70 via-[color:var(--gold)]/25 to-transparent max-w-[520px]" />

            <section aria-label="Meaning" className="border-t border-[color:var(--line-strong)]">
                {pillars.map((p, i) => (
                    <motion.article
                        key={p.k}
                        initial={{ opacity: 0, y: 12 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: true, margin: "-8%" }}
                        transition={{ duration: 0.75, ease, delay: i * 0.06 }}
                        className="grid grid-cols-12 gap-6 py-10 md:py-12 border-b border-[color:var(--line)]"
                    >
                        <div className="col-span-12 md:col-span-3 font-display italic text-[26px] md:text-[32px] text-[color:var(--navy)]">
                            {p.k}
                        </div>
                        <div className="col-span-12 md:col-span-9 flex items-center gap-6">
                            <p className="text-[17px] md:text-[19px] leading-[1.6] text-[color:var(--navy)]/85 max-w-[52ch] flex-1">
                                {p.d}
                            </p>
                            <span aria-hidden className="hidden md:inline-block w-10 h-px bg-[color:var(--gold)]" />
                        </div>
                    </motion.article>
                ))}
            </section>

            <p className="mt-20 font-display italic text-[26px] md:text-[36px] leading-[1.22] text-[color:var(--navy)] max-w-[36ch]">
                {pick3(t3.lighthouse.closing, lang)}
            </p>
        </PageShell>
    );
}
